"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSplashScreenAlternativeButton = exports.StyledSplashScreenAlternativeButtonWrapper = exports.StyledSplashScreenAlternativeButtonContent = exports.StyledSplashScreenAlternativeButtonIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../../helpers");
const Icon_1 = require("../../../../Icon");
const StackView_1 = require("../../../../StackView");
const Text_1 = require("../../../../Text");
exports.StyledSplashScreenAlternativeButtonIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    color: ${({ isDisabled, theme }) => isDisabled ? theme.colorControlIconDisabled : theme.colorButtonRest};
`;
exports.StyledSplashScreenAlternativeButtonContent = styled_components_1.default.div `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: ${helpers_1.SIZE_XL};
    line-height: ${helpers_1.SIZE_XL};
`;
exports.StyledSplashScreenAlternativeButtonWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    margin: 0 auto;
    max-width: 100%;
`;
exports.StyledSplashScreenAlternativeButton = (0, styled_components_1.default)(Text_1.Text) `
    font-size: 16px;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};

    display: inline-flex;
    flex-shrink: 0;

    cursor: pointer;
    outline: none;

    border-radius: ${helpers_1.SIZE_XL};
    padding-left: ${helpers_1.SIZE_M};
    padding-right: ${helpers_1.SIZE_M};
    border-width: ${helpers_1.BASE_BORDER_WIDTH};
    border-style: solid;
    height: ${helpers_1.SIZE_XXXL};

    ${({ disabled, theme }) => !disabled &&
    (0, styled_components_1.css) `
            border-color: ${theme.colorLoginSSOButtonRest};
            background-color: ${theme.colorLoginSSOButtonRest};
            color: ${theme.colorLoginSSOButtonTextRest};

            &:hover,
            &:focus {
                border-color: ${theme.colorLoginSSOButtonHover};
                background-color: ${theme.colorLoginSSOButtonHover};
                color: ${theme.colorLoginSSOButtonTextHover};
            }

            &:active {
                border-color: ${theme.colorLoginSSOButtonOutline};
                background-color: ${theme.colorLoginSSOButtonActive};
                color: ${theme.colorLoginSSOButtonTextActive};
            }
        `}

    ${({ disabled, theme }) => disabled &&
    (0, styled_components_1.css) `
            cursor: default;

            border-color: ${theme.colorLoginSSOButtonDisabled};
            background-color: ${theme.colorLoginSSOButtonDisabled};
            color: ${theme.colorLoginSSOButtonTextDisabled};
        `}
`;
//# sourceMappingURL=SplashScreenAlternativeButton.styles.js.map